import { render, staticRenderFns } from "./RemoveUserFromCommunity.vue?vue&type=template&id=2c0d4687&scoped=true"
import script from "./RemoveUserFromCommunity.vue?vue&type=script&lang=js"
export * from "./RemoveUserFromCommunity.vue?vue&type=script&lang=js"
import style0 from "./RemoveUserFromCommunity.vue?vue&type=style&index=0&id=2c0d4687&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0d4687",
  null
  
)

export default component.exports